<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
*{margin:0;padding:0;}
html,body{
  font-family: "Noto Sans", Arial, Tahoma, sans-serif;
}
.el-input.is-active .el-input__inner, .el-input__inner:focus,.el-select .el-input.is-focus .el-input__inner,.el-form-item.is-success .el-input__inner, .el-form-item.is-success .el-input__inner:focus, .el-form-item.is-success .el-textarea__inner, .el-form-item.is-success .el-textarea__inner:focus{
  border-color:#cfb284;
}
login-codebtn-disable,.el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover{
  background-color:#ccc;
  border-color:#ccc;
  color:#fff;
}
@media (max-width: 640px) {
  .login-form .el-form-item__label{
    display:none;
  }
  .login-form .el-form-item__content{
    margin-left:0px !important;
  }
}
li,ul{
  list-style:none;
}
.clearfix:after {
  content: '\0020';
    display: block;
    overflow: hidden;
    visibility: hidden;
    width: 0;
    height: 0;
    clear: both;
}
</style>



// WEBPACK FOOTER //
// src/App.vue